import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import author from "../../images/LandingPageImage/Author_img.svg";
import useBlogs from "../../services/LandingPage/useBlogs";
import LandingCta from "./LandingCta";
import Footer from "./Footer";
import { ChevronLeft, ChevronRight } from "lucide-react";

const BlogSection = () => {
  const [index, setIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const { blogs, fetchAllBlogs, loading } = useBlogs();

  // ================= Responsive =================
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlePrevious = () => {
    setIndex((prev) =>
      prev === 0 ? blogs.length - (isMobile ? 1 : 4) : prev - 1,
    );
  };

  const handleNext = () => {
    setIndex((prev) =>
      prev >= blogs.length - (isMobile ? 1 : 4) ? 0 : prev + 1,
    );
  };

  useEffect(() => {
    fetchAllBlogs();
  }, [fetchAllBlogs]);

  return (
    <>

      <section className="bg-gray-50 py-12 mt-10">
        <div className="max-w-7xl mx-auto px-4">
          {/* Heading */}
          <div className="text-center mb-10">
            <h2 className="text-3xl font-semibold text-gray-800">
              Blog Updates
            </h2>
            <p className="text-gray-600 mt-2">
              Stay informed with our latest blog posts and join the wave of
              innovation.
            </p>
          </div>

          {/* Cards */}
          {loading ? (
            <div className="text-center py-10">Loading blogs...</div>
          ) : (
            <div className="grid md:grid-cols-4 grid-cols-1 gap-8">
              {blogs
                .slice(index, index + (isMobile ? 1 : 4))
                .reverse()
                .map((card) => (
                  <div
                    key={card.id}
                    className="bg-white rounded-2xl shadow-md hover:shadow-xl transition flex flex-col"
                  >
                    {/* Image */}
                    <div className="h-38 w-full overflow-hidden rounded-t-2xl">
                      <img
                        src={card.image}
                        alt={card.title}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>

                    {/* Content */}
                    <div className="p-6 flex flex-col flex-grow">
                      <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
                        <img src={author} alt="author" className="w-4 h-4" />
                        <span>{card.author}</span>
                      </div>

                      <h3 className="text-lg font-semibold mb-3 line-clamp-2">
                        <Link
                          to={`/blog/${card.post_slug}`}
                          className="hover:text-green-600 transition"
                        >
                          {card.title}
                        </Link>
                      </h3>

                      <p className="text-gray-600 text-sm line-clamp-3">
                        {card.description}
                      </p>

                      <Link
                        to={`/blogs/${card.post_slug}`}
                        className="text-green-600 font-medium mt-auto pt-4"
                      >
                        Read more →
                      </Link>
                    </div>
                  </div>
                ))}
            </div>
          )}

          {/* Navigation Arrows */}
          <div className="flex justify-center gap-10 mt-8">
            {/* Previous Button */}
            <button
              onClick={handlePrevious}
              className="cursor-pointer hover:opacity-70 transition-opacity"
            >
              <ChevronLeft
                className="w-8 h-8 text-gray-700"
                strokeWidth={2.5}
              />
            </button>

            {/* Next Button */}
            <button
              onClick={handleNext}
              className="cursor-pointer hover:opacity-70 transition-opacity"
            >
              <ChevronRight
                className="w-8 h-8 text-gray-700"
                strokeWidth={2.5}
              />
            </button>
          </div>
        </div>
      </section>

      <LandingCta />
      <Footer />
    </>
  );
};

export default BlogSection;
